import { useCallback } from 'react';
import { useDelivery } from 'api/hooks/useDelivery';
import usePrintAllTrayImages from 'api/hooks/usePrintAllTrayImages';
import theme from 'App.theme';
import Button from 'components/Button';
import Dialog from 'components/Dialog';
import { useLanguage } from 'context/AppContext';
import { useNavigateToImplantsPage } from 'hooks/useNavigateToImplantsPage';

type Props = {
  deliveryId: string;
  onClose: () => void;
  onReturnToDeliveryInformationPage: () => void;
  onReturnToActionItems: () => void;
  noSets?: boolean;
};

export const SetsCheckedInDialog = ({
  deliveryId,
  onReturnToDeliveryInformationPage,
  onReturnToActionItems,
}: Props) => {
  const lang = useLanguage()[0].SetsCheckedInDialog;

  const { data: delivery } = useDelivery(deliveryId);

  const navigateToImplantsPage = useNavigateToImplantsPage();

  const onConfirm = useCallback(async () => {
    if (delivery?.sets.length !== 0) {
      navigateToImplantsPage(deliveryId);
    }
  }, [delivery?.sets, deliveryId, navigateToImplantsPage]);

  const { openTrayImageInNewTab, loading: trayImageLoading } = usePrintAllTrayImages(deliveryId, {
    kitInstanceId: undefined,
    trayInstanceId: undefined,
  });

  const onPrintAllDeliveryInformation = useCallback(async () => {
    await openTrayImageInNewTab();
  }, [openTrayImageInNewTab]);

  return (
    <Dialog open={true} title={lang.title} allowClose={false}>
      <div
        style={{
          marginTop: theme.layout.spacing.medium,
          display: 'flex',
          flexDirection: 'column',
          gap: theme.layout.spacing.medium,
        }}
      >
        <Button colors="white on active" onClick={onConfirm}>
          {lang.beginImplantCheckIn}
        </Button>

        <Button colors="white on active" onClick={onReturnToDeliveryInformationPage}>
          {lang.goToDeliveryInformationPage}
        </Button>

        <Button colors="white on active" onClick={onReturnToActionItems}>
          {lang.returnToActionItems}
        </Button>
        <Button
          label={lang.printAllDeliveryInformation}
          onClick={onPrintAllDeliveryInformation}
          colors="white on active"
          disabled={trayImageLoading}
          loading={trayImageLoading}
        />
      </div>
    </Dialog>
  );
};
